import { v4 as uuidV4 } from 'uuid'

// Generate a unique SDK GUID for the running SDK instance.
const sdkId = uuidV4()

export default sdkId
